import React from "react";
import { formatRichText } from "../lib/richText";

const RichText = ({ as: Tag = "div", value, className, multiline = true }) => {
  return (
    <Tag
      className={className}
      dangerouslySetInnerHTML={{ __html: formatRichText(value, { multiline }) }}
    />
  );
};

export default RichText;
